import { withInstall, withNoopInstall } from "@xplus/utils/with-install";
import tooltip from "./src/tooltip.vue";
import tooltipIcon from "./src/tooltip-icon.vue";
export const xTooltip = withInstall(tooltip, { tooltipIcon });
export default xTooltip;
export const xTooltipIcon = withNoopInstall(tooltipIcon);
export * from "./src/tooltip";
